import { render, staticRenderFns } from "./HRBookDetail.vue?vue&type=template&id=15440961"
import script from "./HRBookDetail.vue?vue&type=script&lang=js"
export * from "./HRBookDetail.vue?vue&type=script&lang=js"
import style0 from "./HRBookDetail.vue?vue&type=style&index=0&id=15440961&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports